// extracted by mini-css-extract-plugin
export default {"button":"TeamTab_button__2RjnN","hovered":"TeamTab_hovered__4itH-","neighbor":"TeamTab_neighbor__EMtKa"};